import React from 'react';
import { LandingPage } from '../src/features';

function MainPage(): JSX.Element {
  return <LandingPage />;
}

export default MainPage;
